<template>
  <div class="wt-asset-editor-layout-custom">
    <div class="wt-asset-editor-header" :style="headerStyle">
      <transition name="ae-fade">
        <slot name="header" />
      </transition>
    </div>

    <div class="wt-editor-view-inner-scroll">
      <div class="wt-editor-view-inner">
        <div class="-top-right-floating wt2-sg">
          <slot name="top-right-floating">
            <div
              v-if="showTranscriptForEffectPage"
              class="wt2-color-link wt2-text-n"
              v-text="toggleTranscriptLabel"
              @click="$_onToggleTranscript"
            />
          </slot>
        </div>

        <div class="wt-asset-left-bar-custom">
          <slot name="left" />
        </div>

        <div class="wt-asset-editor-middle-custom">
          <transcript-layer
            :toggle="toggleTranscript"
            :marginTop="49"
            :arrowRight="68"
          />
          <slot name="main" />
          <div class="wt-editor-bottom-bar-custom">
            <slot name="bottom" />
          </div>
        </div>
      </div>
    </div>

    <div class="wt-asset-editor-footer">
      <transition name="ae-fade">
        <slot name="footer" />
      </transition>
    </div>
  </div>
</template>

<script>
import bus from 'v/AssetEditor/AssetEditorEventBus';
import TranscriptMixin from 'AssetEditor/functionality/Info/TranscriptMixin';

export default {
  mixins: [TranscriptMixin],

  props: {
    headerHeight: { required: false, default: 80 },
  },

  computed: {
    headerStyle() {
      return {
        height: `${this.headerHeight}px`,
      };
    },
  },

  methods: {
    moreInfo() {
      bus.$emit('moreInfo');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'asset_editor/_variables.scss';

.wt-asset-editor-layout-custom {
  .wt-editor-view-inner-scroll {
    overflow: auto;
    height: calc(100% - #{$asset-editor-action-bar-height} - #{$footer-height});
    transition: height 1s;

    .wt-editor-view-inner {
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      overflow-y: auto;
      min-width: min-content;
      position: relative;

      .wt-asset-left-bar-custom {
        width: 480px;
        height: 100%;
        background-color: rgba($color-black, 0.03);
        overflow: hidden;
      }

      .wt-asset-editor-middle-custom {
        height: 100%;
        overflow: hidden;
        display: grid;
        grid-template-columns: minmax(56px, 1fr) 688px minmax(56px, 1fr);
        grid-template-rows: 110px 387px 1fr;
        flex: 1;
        position: relative;
        background-color: rgba(0, 0, 0, 0.07);
        padding: 4px;

        .wt-editor-bottom-bar-custom {
          grid-row: 3 / 4;
          grid-column: 2 / 3;
          z-index: 0;
        }
      }

      .-top-right-floating {
        position: absolute;
        top: 20px;
        right: 30px;
        z-index: 1;
      }

      .-button-container {
        font-size: 0;
        button {
          margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 30px;
        z-index: 1;
      }

      .wt-editor-bottom-bar {
        border: 1px solid transparent;
        grid-row: 3 / 4;
        grid-column: 2 / 3;
      }

      .wt-asset-left-bar,
      .wt-asset-editor-middle,
      .wt-asset-right-bar,
      .wt-asset-top-bar {
        margin: auto;
      }

      .wt-asset-editor-main {
        border: 1px solid rgba(0, 0, 0, 0.2);
        grid-row: 2 / 3;
        grid-column: 2 / 3;
      }

      .wt-asset-left-bar,
      .wt-asset-right-bar {
        background-color: #f7f7f7;
        width: 480px;
        min-height: $asset-height;
        height: 100%;
        overflow: auto;
        z-index: 0;
      }

      .wt-asset-editor-middle {
        --grid-middle-row: 688px;
        height: 100%;
        overflow: auto;
        display: grid;
        grid-template-columns: minmax(56px, 1fr) var(--grid-middle-row) minmax(
            56px,
            1fr
          );
        grid-template-rows: 110px 387px 1fr;
        flex: 1;

        position: relative;
        background-color: rgba(0, 0, 0, 0.07);
      }
    }
  }
}
</style>
